/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Status of a verification item
 */
export type VerificationStatus = typeof VerificationStatus[keyof typeof VerificationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerificationStatus = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  NOT_PROVIDED: 'NOT_PROVIDED',
} as const;
